import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const SuccessVsFailureChart = ({ successCount = 289, failureCount = 11 }) => {
  const data = [
    { name: "Success", value: successCount, color: "#0E5E44" },
    { name: "Failure", value: failureCount, color: "#EF4444" },
  ];

  return (
    <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm flex flex-col justify-between h-full min-h-[360px]">
      <h3 className="text-xl font-bold text-gray-900 mb-2">Total Success vs Failure</h3>

      <div className="w-full h-64 relative flex items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={70}
              outerRadius={98}
              paddingAngle={3}
              dataKey="value"
              startAngle={90}
              endAngle={-270}
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`${value} calls`, name]}
              contentStyle={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                border: "1px solid #f3f4f6",
                padding: "8px 12px",
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className="flex items-center justify-center gap-8 pt-2">
        <div className="flex items-center gap-2">
          <span className="w-3.5 h-3.5 rounded-full bg-[#0E5E44]"></span>
          <span className="text-sm font-semibold text-gray-700">Success</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-3.5 h-3.5 rounded-full bg-[#EF4444]"></span>
          <span className="text-sm font-semibold text-gray-700">Failure</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessVsFailureChart;
